module.exports = __webpack_public_path__ + "static/js/1.d67532d1.chunk.worker.js"